import { IGroup } from "../interfaces/IGroup";
import { IGroupMemberInfo } from "../interfaces/IGroupMemberInfo";
import { IRoadmap } from "../interfaces/IRoadmap";
import { IUser } from "../interfaces/IUser";

export default class RoadmapService {

  public static getRoadmapForUser(user, masterKey?: string): Promise<IRoadmap> {
    return new Promise((resolve) => {
      fetch(`https://mindjuice.herokuapp.com/parse/classes/Roadmap/?where={\"userId\":\"${user.id}\"}`, {
        headers: {
          'X-Parse-Application-Id': 'mindjuice',
          'X-Parse-Session-Token': user.sessionToken,
          'X-Parse-Master-Key': masterKey
        }
      }).then((response) => {
        if (!response.ok) {
          resolve(undefined);
        } else {
          return response.json();
        }
      }).then(response => {
        if (response.results.length > 0) {
          resolve(response.results[0]);
        }
        resolve(undefined);
      }).catch((error) => {
        console.log(error);
        resolve(undefined);
      });
    });
  }

  public static createRoadmap(roadmap: IRoadmap): Promise<void> {
    return new Promise((resolve) => {
      fetch(`https://mindjuice.herokuapp.com/parse/classes/Roadmap/`, {
        method: "POST",
        headers: {
          'X-Parse-Application-Id': 'mindjuice'
        },
        body: JSON.stringify(
          roadmap
        )
      }).then((response) => {
        if (!response.ok) {
          resolve();
        } else {
          resolve();
        }
      }).catch((error) => {
        console.log(error);
        resolve();
      });
    });
  }

  public static updateRoadmap(roadmap: IRoadmap, user): Promise<void> {
    return new Promise((resolve) => {
      fetch(`https://mindjuice.herokuapp.com/parse/classes/Roadmap/${roadmap.objectId}`, {
        method: "PUT",
        headers: {
          'X-Parse-Application-Id': 'mindjuice',
          'X-Parse-Session-Token': user.sessionToken
        },
        body: JSON.stringify({
          answers: roadmap.answers,
        })
      }).then((response) => {
        if (!response.ok) {
          resolve();
        } else {
          resolve();
        }
      }).catch((error) => {
        console.log(error);
        resolve();
      });
    });
  }

  // Status Sheet

  public static createStatusSheet(statusSheet: any): Promise<void> {
    return new Promise((resolve) => {
      fetch(`https://mindjuice.herokuapp.com/parse/classes/StatusSheet/`, {
        method: "POST",
        headers: {
          'X-Parse-Application-Id': 'mindjuice'
        },
        body: JSON.stringify(
          statusSheet
        )
      }).then((response) => {
        if (!response.ok) {
          resolve();
        } else {
          resolve();
        }
      }).catch((error) => {
        console.log(error);
        resolve();
      });
    });
  }

  public static getStatusSheets(user: IUser, masterKey?: string): Promise<any[]> {
    return new Promise((resolve) => {
      fetch(`https://mindjuice.herokuapp.com/parse/classes/StatusSheet/`, {
        headers: {
          'X-Parse-Application-Id': 'mindjuice',
          'X-Parse-Session-Token': user.sessionToken,
          'X-Parse-Master-Key': masterKey
        }
      }).then((response) => {
        if (!response.ok) {
          resolve(undefined);
        } else {
          return response.json();
        }
      }).then(response => {
        if (response.results.length > 0) {
          resolve(response.results);
        }
        resolve(undefined);
      }).catch((error) => {
        console.log(error);
        resolve(undefined);
      });
    });
  }

}